export default "__VITE_ASSET__71d70ec6__"